export const AI_IMAGES_REQUEST = "AI_IMAGES_REQUEST";
export const AI_IMAGES_SUCCESS = "AI_IMAGES_SUCCESS";
export const AI_IMAGES_FAILURE = "AI_IMAGES_FAILURE";
